import { ModalProps } from '@billy/design-system'

import { EInvoiceStatus, REFUSE_I18N_KEYS } from '@features/eInvoicing/constants'
import { LifecycleActionModal } from '@features/eInvoicing/elements/LifecycleActionModal'
import type { EInvoiceLifecycleTrackingSource } from '@views/receipts/enums/tracking'

interface EDocumentRejectionModalProps extends ModalProps {
  attachmentId?: string
  onSuccess?: () => void
  trackingSource: EInvoiceLifecycleTrackingSource
  previousStatus?: EInvoiceStatus | null
}

export const FrenchMarketEInvoiceRejectionModal = ({
  attachmentId,
  onSuccess,
  trackingSource,
  previousStatus,
  ...modalProps
}: EDocumentRejectionModalProps) => {
  if (!attachmentId) {
    return null
  }

  return (
    <LifecycleActionModal
      action="refuse"
      i18nKeys={REFUSE_I18N_KEYS}
      buttonColor="danger"
      attachmentId={attachmentId}
      onSuccess={onSuccess}
      trackingSource={trackingSource}
      previousStatus={previousStatus}
      {...modalProps}
    />
  )
}
